export default "__VITE_ASSET__DrNHOoy0__"